webpackJsonp([3],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(108);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("1ffe1e78", content, true, {});

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, ".v-btn--bottom[data-v-6a63bfd0]:not(.v-btn--absolute){bottom:35px}", "", {"version":3,"sources":["/vue-ui/src/views/Todo.vue"],"names":[],"mappings":"AACA,sDACE,WAAa,CACd","file":"Todo.vue","sourcesContent":["\n.v-btn--bottom[data-v-6a63bfd0]:not(.v-btn--absolute) {\n  bottom: 35px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"max-width":"600px"}},[_c('v-card-title',[_c('h1',[_vm._v(_vm._s(_vm.bike != null ? _vm.bike.name : '')+" - Todos")])]),_vm._v(" "),_c('v-card-text',[_c('v-list',_vm._l((_vm.bike.todos),function(todoItem){return _c('v-list-tile',{key:todoItem.id},[_c('v-list-tile-content',[_c('v-switch',{attrs:{"label":todoItem.text,"input-value":todoItem.checked},on:{"change":function($event){return _vm.updateCheckBox(todoItem, $event)}}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":"","title":_vm.$vuetify.t('$vuetify.todo.editbtn')},on:{"click":function($event){return _vm.showEditDialog(todoItem)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("edit")])],1)],1)],1)}),1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","fixed":"","small":_vm.isMobile,"bottom":"","right":"","fab":"","title":_vm.$vuetify.t('$vuetify.todo.addfab')},on:{"click":_vm.showNewDialog}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.editItem? _vm.$vuetify.t('$vuetify.todo.dialog.edittitle') : _vm.$vuetify.t('$vuetify.todo.dialog.newtitle')))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"placeholder":"Todo","rules":_vm.inputRules},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.dialogOk($event)}},model:{value:(_vm.dialogContent),callback:function ($$v) {_vm.dialogContent=$$v},expression:"dialogContent"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.editItem)?_c('v-btn',{attrs:{"flat":"","outline":""},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.cancel'))},on:{"click":function($event){_vm.showDialog = false}}},[_vm._v("\n          Cancel\n        ")]):_vm._e(),_vm._v(" "),(_vm.editItem)?_c('v-btn',{attrs:{"flat":"","outline":""},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.delete'))},on:{"click":_vm.clickDeleteTodo}},[_vm._v("\n          Delete\n        ")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":""},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.ok'))},on:{"click":_vm.dialogOk}},[_vm._v("\n          OK\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Todo_vue__ = __webpack_require__(91);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a63bfd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Todo_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a63bfd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Todo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a63bfd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Todo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StringMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StringMixin__["a" /* default */]],
  name: 'Todos',
  data: function data() {
    var _this = this;

    return {
      showDialog: false,
      dialogContent: '',
      editItem: null,
      isMobile: false,
      inputRules: [function (v) {
        return !!v || _this.$vuetify.t('$vuetify.errormsg.required');
      }, function (v) {
        return v.length >= 3 || _this.$vuetify.t('$vuetify.errormsg.minlength');
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([]), {
    bikeId: function bikeId() {
      return this.$route.params.bikeId;
    },
    bike: function bike() {
      var bike = this.$store.getters.bike(this.bikeId);
      if (bike) {
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('title-change', bike.name + ' - ToDos');
      }
      return bike;
    }
  }),
  mounted: function mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['updateTodo', 'addTodo', 'deleteTodo']), {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < 900;
    },
    updateCheckBox: function updateCheckBox(item, checked) {
      this.updateTodo({ bikeId: this.bikeId, todoId: item.id, checked: checked });
    },
    showEditDialog: function showEditDialog(item) {
      this.dialogContent = item.text;
      this.editItem = item;
      this.showDialog = true;
    },
    showNewDialog: function showNewDialog() {
      this.dialogContent = '';
      this.editItem = null;
      this.showDialog = true;
    },
    dialogOk: function dialogOk() {
      if (!this.isNullOrEmpty(this.dialogContent)) {
        if (this.editItem) {
          this.updateTodo({ bikeId: this.bikeId, todoId: this.editItem.id, text: this.dialogContent });
        } else {
          this.addTodo({ text: this.dialogContent, checked: false, bikeId: this.bikeId });
        }
        this.showDialog = false;
      }
    },
    clickDeleteTodo: function clickDeleteTodo() {
      this.deleteTodo({ bikeId: this.bikeId, todoId: this.editItem.id });
      this.showDialog = false;
    }
  })
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.a215165338141a61c549.js